import { t } from '@lingui/core/macro';
import { ConfirmDialog } from '@pocketlaw/tetris';
export function RemoveConversationModal(props) {
    const { loading = false, onCancel, onConfirm } = props;
    const heading = t({
        comment: 'Remove assistant chat conversation confirm dialog - title',
        message: 'Remove conversation',
    });
    const confirm = t({
        comment: 'Remove assistant chat conversation confirm dialog - confirm button label',
        message: 'Remove',
    });
    const cancel = t({
        comment: 'Remove assistant chat conversation confirm dialog - cancel button label',
        message: 'Cancel',
    });
    const message = t({
        comment: 'Remove assistant chat conversation confirm dialog - message',
        message: 'Are you sure you want to remove this conversation?',
    });
    return (<ConfirmDialog size="sm" appearance="danger" loading={loading} title={heading} confirm={confirm} cancel={cancel} onConfirm={onConfirm} onCancel={onCancel}>
      {message}
    </ConfirmDialog>);
}
